import { createMarkup } from '../../helpers/markup'
import themeConfig from '../../../theme.config'

const TitleBlock = (props) => {
  return (
    <>
      {(props.title || props.description) && (
        <div className={`${props.headingClass ?? ''}`}>
          {props.title && (
            <div
              data-type="section-title"
              className={`font-highlight ${themeConfig.settings.useReadableContentWidth ? 'max-w-prose' : ''}`}
              data-rte="true"
              dangerouslySetInnerHTML={createMarkup(props.title)}
            ></div>
          )}
          {props.description && (
            <div
              className={`${props.title && 'mt-10'} ${themeConfig.settings.useReadableContentWidth ? 'max-w-prose' : ''}`}
              data-type="section-description"
              data-rte="true"
              dangerouslySetInnerHTML={createMarkup(props.description)}
            ></div>
          )}
        </div>
      )}
    </>
  )
}

export default TitleBlock
